import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";

export type PropsType = any;

const Wrap = styled.select<Default>`
   ${typography.other.t5}
   outline: none;
   border: 1px solid ${typography.other.color.gray[2]};
   color: black;
   border-radius: 4px;
   height: 40px;
   box-sizing: border-box;
   padding: 0px 10px;
   width: 100%;
   flex-grow: 1;
   &::placeholder {
      color: ${typography.other.color.gray[2]};
   }
   ${({ css }) => css}
`;

export default function AtomSelect(props: PropsType) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
